import { render, staticRenderFns } from "./ControlsPanel.vue?vue&type=template&id=de7fff1c&scoped=true&"
import script from "./ControlsPanel.vue?vue&type=script&lang=js&"
export * from "./ControlsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ControlsPanel.vue?vue&type=style&index=0&id=de7fff1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7fff1c",
  null
  
)

export default component.exports